export const UPLOAD_FOLDER = {
  PERSONAL_PARTICULAR: 'personal-particular',
  SUPPLIER_INVOICE: 'supplier_invoice',
  RESALE: 'resale',
  ECDD: 'ecdd',
};
